<template>
  <div>
    <PromoBgDesktop
      :title="'Благодаря Линк Вебинарам, компания Siemens сократила расходы на проведение презентаций для партнеров и клиентов'"
      :bg-img-src="require('~/assets/img/clients-items/siemens/siemens-bg.jpg')"
      :bg-img-src-webp="require('~/assets/img/clients-items/siemens/siemens-bg.webp')"
      :bg-img-ext="'jpg'"
    />

    <section class="page-section _with-border text-content">
      <div class="inner-width">
        <p>
          "Технология вебинаров оказалась для нас самым удобным и экономически выгодным решением для проведения обучения
          наших региональных представителей. При выборе поставщика для нас важными условиями были высокое качество
          связи, безопасность и надежность провайдера, а также удобный и интуитивно понятный интерфейс. Линк Вебинары
          удовлетворил всем нашим требованиям"
          <br><br>

          <strong>Виктор Архипенков,</strong> начальник службы информационно-технического обслуживания, Компания
          Siemens.
        </p>

        <h2>О заказчике</h2>
        <p>
          Siemens - мировой лидер в области электроники и электротехники. Концерн действует в таких областях, как
          индустрия и энергетика, а также в сфере здравоохранения. Около 405 000 сотрудников разрабатывают и производят
          продукцию, проектируют и создают системы и оборудование, предлагают индивидуальные решения для конкретных
          заказчиков. Компания Siemens была основана более 160 лет назад. В 2009 финансовом году (по состоянию на 30
          сентября) оборот концерна составил 76,7 млрд. евро. В России и СНГ концерн присутствует более чем в 40 городах
          и является одним из ведущих поставщиков продукции, услуг и комплексных решений для модернизации ключевых
          отраслей экономики и инфраструктуры. В данном кластере Siemens насчитывает более 3300 сотрудников. России,
          Беларуси и Центральной Азии в 2009 финансовом году (по состоянию на 30 сентября) составил свыше 1,4 млрд.
          евро.
        </p>

        <h2>Задачи</h2>
        <p>
          Продуктовая линейка Siemens постоянно обновляется и расширяется, и для компании, олицетворяющей технический
          прогресс и инновации, очень важным является скорость внедрения новейших технологий и продуктов на российский
          рынок. В силу географических особенностей России партнеры играют существенную роль в продвижении решений
          Siemens в регионы. Поэтому своевременное информирование и ознакомление всех региональных представительств с
          технологическими новинками Siemens является необходимым условием успешности бизнеса. Ранее обучение партнеров
          компании проходило вживую. Однако не все партнеры из регионов имели возможность приезжать на каждый семинар в
          столицу. Поэтому им отправлялись презентации и другие материалы по электронной почте, таким образом, снижалась
          эффективность обучения. Встал вопрос о поиске дистанционного способа проведения продуктовых презентаций и
          обучающих семинаров для региональных представительств и партнеров Siemens.
        </p>

        <h2>Решение</h2>
        <p>
          Вебинары на платформе Линк Вебинары оказались оптимальным решением для организации удаленных маркетинговых
          презентаций и семинаров для сотен представителей и дистрибьюторов компании Siemens. Каждый месяц Siemens
          проводит вебинары, на которых собираются до 100 участников из различных регионов России и стран СНГ. Партнеры
          могут слышать и видеть представителей компании Siemens, ознакомиться с продуктовыми новинками, а также задать
          интересующие вопросы прямо по ходу презентации.
        </p>

        <h2>Результаты</h2>
        <p>
          Вебинары на платформе Линк Вебинары позволили Компании Siemens на порядок сократить организационные расходы на
          аренду залов для проведения продуктовых презентаций и обучающих семинаров для региональных представительств и
          партнеров Компании. Кроме того, формат вебинаров оказался экономически выгодной альтернативой для партнеров,
          так как сделал возможным проходить обучение и принимать участие в семинаре прямо с рабочего места.
        </p>

        <h2>Отзыв</h2>
        <p>
          "Технология вебинаров оказалась для нас самым удобным и экономически выгодным решением для проведения обучения
          наших региональных представителей. При выборе поставщика для нас важными условиями были высокое качество
          связи, безопасность и надежность провайдера, а также удобный и интуитивно понятный интерфейс. Линк Вебинары
          удовлетворил всем нашим требованиям"
          <br><br>

          <strong>Виктор Архипенков,</strong> начальник службы информационно-технического обслуживания Компании
          Siemens.
        </p>
      </div>
    </section>

    <Sharing
      :vk-link="'https://oauth.vk.com/authorize?client_id=-1&redirect_uri=https%3A%2F%2Fvk.com%2Fshare.php%3Furl%3Dhttps%3A%2F%2Fwebinar.ru%2Fclients%2Fsiemens%26comment%3D%25D0%259A%25D0%25BB%25D0%25B8%25D0%25B5%25D0%25BD%25D1%2582%2520Mts-Link.ru%2520%25D0%25BA%25D0%25BE%25D0%25BC%25D0%25BF%25D0%25B0%25D0%25BD%25D0%25B8%25D1%258F%2520Siemens%2520-%2520Mts-Link.ru&display=widget'"
    />

    <ClientsSeeMoreDesktop :clients-see-more="clientsSeeMore"/>
  </div>
</template>
<script>

import PromoBgDesktop from "~/components/Desktop/Common/PromoBgDesktop.vue";
import Sharing from "~/components/Common/Sharing.vue";
import ClientsSeeMoreDesktop from "~/components/Desktop/Clients/ClientsSeeMoreDesktop.vue";

export default {
  name: 'ClientsSiemensDesktop',
  components: {ClientsSeeMoreDesktop, Sharing, PromoBgDesktop},
  props: {
    clientsSeeMore: {
      type: Array,
      default: () => [],
    }
  },
};
</script>
<style lang="scss" scoped>
@import "assets/scss/client-desktop.scss";
</style>
